module.exports = __webpack_public_path__ + "static/img_01-c0ca99e242a22cdf00265219d311c146.png";